import { render, staticRenderFns } from "./SharedItemNotification.vue?vue&type=template&id=7aa051a2&scoped=true"
import script from "./SharedItemNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedItemNotification.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SharedItemNotification.vue?vue&type=style&index=0&id=7aa051a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa051a2",
  null
  
)

export default component.exports